import { MessageCircle, Phone } from "lucide-react";
import { COMPANY } from "@/lib/company";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3 items-end">
      <a
        href={`tel:${COMPANY.phoneIntl}`}
        data-testid="floating-call"
        className="lg:hidden flex items-center gap-2 bg-neutral-900 hover:bg-neutral-800 text-white rounded-full pl-4 pr-5 py-3 shadow-xl transition-transform hover:scale-105"
        aria-label="Call renovation expert"
      >
        <Phone className="w-4 h-4" />
        <span className="text-sm font-medium">Call</span>
      </a>
      <a
        href={COMPANY.whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        className="flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebd5a] text-white rounded-full pl-4 pr-5 py-3 shadow-xl transition-transform hover:scale-105"
        aria-label="WhatsApp Renovation Expert"
      >
        <MessageCircle className="w-5 h-5" />
        <span className="text-sm font-medium hidden sm:inline">WhatsApp Renovation Expert</span>
        <span className="text-sm font-medium sm:hidden">WhatsApp</span>
      </a>
    </div>
  );
}
